/**
 * Generated by orval from the Collective Payroll API contract. Do not edit manually.
 */

/**
 * * `unavailable` - unavailable
 * * `not_found` - not_found
 */
export type PayrollDocumentUnavailableReasonEnum =
    (typeof PayrollDocumentUnavailableReasonEnum)[keyof typeof PayrollDocumentUnavailableReasonEnum];

export const PayrollDocumentUnavailableReasonEnum = {
    unavailable: 'unavailable',
    not_found: 'not_found',
} as const;
